import React from 'react';
import {Spin} from "antd";

const LoadingSpin = ()=>(<div className="spinner"><Spin size="large"/></div>)

export default LoadingSpin